import Dropdown from './dropdown'

const install = Alpine => {
    Alpine.data('dropdown', Dropdown)
}

export {
    Dropdown,
    install,
}
